import ProductRecommender from '@components/components/ProductRecommender/ProductRecommender';
import Container from '@components/components/Container/Container';
import React from 'react';

const CmsProductRecommender = ({ initType, header, links }) => {
  const handleSubmit = ({ type }) => {
    window.open(`${links[type]}#productContent`, '_self');
  };
  const handleChange = () => {};
  return (
    <Container size="lg">
      <ProductRecommender
        header={header}
        initType={initType}
        onChange={handleChange}
        onSubmit={handleSubmit}
      />
    </Container>
  );
};

CmsProductRecommender.size = 'full';

export default CmsProductRecommender;
